import { chakra } from '@chakra-ui/system';
import type { HTMLChakraProps } from '@chakra-ui/system';
import type { PropsWithChildren } from 'react';

import { useContainerStyles } from './';

export type ContainerHeaderProps = PropsWithChildren<unknown> &
  HTMLChakraProps<'div'>;

export const ContainerHeader = ({
  children,
  ...props
}: ContainerHeaderProps) => {
  const styles = useContainerStyles();

  return (
    <chakra.div __css={styles.containerHeader} {...props}>
      {children}
    </chakra.div>
  );
};
ContainerHeader.displayName = 'ContainerHeader';
